export default class Navigation {

  constructor(navEl, menuPanelEl) {
    this.navEl = navEl;
    this.menuPanel = menuPanelEl;
    this.navOpen = this.navEl.querySelector('.toggle-nav');
    this.navClose = this.menuPanel.querySelector('.toggle-nav');
    this.navLogo = this.navEl.querySelector('.site-logo');
    this.menuActiveClasses = {
      'logo': 'site-logo--slide-out',
      'menuPanel': 'menu-panel--active'
    };
    this.init();
  }

  init() {
    this.navOpen.addEventListener('click', () => {
      this.navLogo.classList.add(this.menuActiveClasses.logo);
      this.menuPanel.classList.add(this.menuActiveClasses.menuPanel);
    });

    this.navClose.addEventListener('click', () => {
      this.navLogo.classList.remove(this.menuActiveClasses.logo);
      this.menuPanel.classList.remove(this.menuActiveClasses.menuPanel);
    });
  }
}